import React from "react";

const BetaTag = () => {
    return <span style={{color: "blue", fontSize: "0.6em", verticalAlign: "top"}}>BETA</span>
}

export default BetaTag;